<template>
  <v-layout row wrap v-if="screener">
    <!-- Show thumbnail of screener -->
    <v-flex xs12 v-if="screener.thumbnail_url">
      <!-- Film poster -->
      <v-card flat>
        <v-img
          width="100%"
          height="auto"
          v-if="screener.thumbnail_url"
          :src="screener.thumbnail_url"
        ></v-img>

        <v-container
          v-else
          bg
          fill-height
          grid-list-md
          text-xs-center
          class="media_file_container"
        >
          <v-layout row wrap align-center>
            <v-flex>
              <v-icon size="100">$vuetify.icons.rms_image_not_found</v-icon>
              <div class="title secondary--text">
                {{ $t("screener.film.thumbnails.not_available") }}
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <!-- Show First film thumbnail if thumbnail is not available  -->
    <v-flex xs12 v-else>
      <!-- Film poster -->
      <v-card flat>
        <v-img
          width="100%"
          height="auto"
          v-if="screener.films[0].thumburls"
          :src="screener.films[0].thumburls"
        ></v-img>
        <v-container
          v-else
          bg
          fill-height
          grid-list-md
          text-xs-center
          class="media_file_container"
        >
          <v-layout row wrap align-center>
            <v-flex>
              <v-icon size="100">$vuetify.icons.rms_image_not_found</v-icon>
              <div class="title secondary--text">
                {{ $t("screener.film.thumbnails.not_available") }}
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <!-- Content -->

    <v-flex xs12>
      <div>
        <v-toolbar color="secondary" dark tabs>
          <v-toolbar-title class="background--text">{{ screener.title }}</v-toolbar-title>

          <template v-if="screener.films.length > 1" v-slot:extension>
            <v-tabs v-model="tab" color="secondary">
              <v-tabs-slider color="background"></v-tabs-slider>
              <v-tab href="#overview" class="background--text">{{
                $t("screener.overview.tab.screener.details")
              }}</v-tab>
              <v-tab class="background--text" v-if="screener.films.length > 1" href="#movies">{{
                $t("screener.overview.tab.screener.movies")
              }}</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="tab">
          <v-tab-item value="overview">
            <v-card>
              <v-flex xs12 pa-3 class="word-break">
                <v-layout row wrap class="primary--text">
                  <!-- Credits -->
                  <v-flex
                    v-if="isCreditOrTrailerAvailable"
                    xs12
                    md3
                    :class="[
                      $vuetify.breakpoint.width > 959
                        ? $vuetify.rtl
                          ? 'pl-2'
                          : 'pr-2'
                        : '',
                        'mb-2',
                        isSecondaryColorWhite(currentCompany) || currentCompany.id == 56 ? 'black--text' : 'secondary--text'
                    ]"
                  >
                    <!-- Producer -->
                    <div class="secondary--text" v-if="screener.films[0].producer_name">
                      <span class="subheading pr-2">{{
                        $t("film.producer")
                      }}</span>
                      <span class="subheading font-weight-medium">
                        {{
                          screener.films[0].producer_name
                        }}
                      </span>
                    </div>
                    <!-- Director -->
                    <div class="secondary--text" v-if="screener.films[0].director_name">
                      <span class="subheading pr-2">{{
                        $t("film.director")
                      }}</span>
                      <span class="subheading font-weight-medium">
                        {{
                          screener.films[0].director_name
                        }}
                      </span>
                    </div>
                    <div class="mt-2">
                      <v-btn
                        class="mx-0"
                        color="primary background--text"
                        dark
                        v-if="screener.films[0].trailer"
                        @click="showTrailerpreview({ film: screener.films[0] })"
                      >
                        <v-icon small>movie</v-icon>
                        &nbsp;{{ $t("screener.btn.watch_trailer") }}
                      </v-btn>
                    </div>
                  </v-flex>
                  <!-- Description -->
                  <v-flex
                    xs12
                    :md9="isCreditOrTrailerAvailable"
                    :md12="screener.films.length > 1"
                    :class="[
                      $vuetify.breakpoint.width > 959
                        ? $vuetify.rtl
                          ? 'pr-2'
                          : 'pl-2'
                        : '',
                        'mb-2',
                        isSecondaryColorWhite(currentCompany) || currentCompany.id == 56 ? 'black--text' : 'secondary--text'
                    ]"
                  >
                    <!-- User collection description if available -->
                    <div
                      v-if="screener.films.length > 1 && screener.description"
                      class="subheading font-weight-medium text-align ql-editor me-screener-desc secondary--text"
                      v-html="screener.description"
                    ></div>
                    <!-- If collection description is not available then use first film description -->
                    <div
                      v-else
                      class="subheading font-weight-medium text-align ql-editor me-screener-desc secondary--text"
                      v-html="screener.films[0].description"
                    ></div>
                    <!-- Oraganizing body branding -->
                    <div v-if="screener.logo_url" class="text-xs-left pt-3">
                      <img
                        class="cursor-pointer"
                        :src="screener.logo_url"
                        height="60vh"
                        style="max-width: 100%"
                      />
                    </div>
                    <!-- Zoom info -->
                    <ZoomInfo :screener="screener"></ZoomInfo>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="screener.films.length > 1" value="movies">
            <FilmList
              @watchTrailer="showTrailerpreview"
              :screener="screener"
              :showDescription="true"
            ></FilmList>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-flex>

    <!-- Trailer popup -->
    <v-dialog
      max-width="80vmin"
      v-if="showPreview"
      v-model="showPreview"
      persistent
    >
      <v-card>
        <v-card-title>
          <div class="title primary--text">
            {{ $t("screener.trailer.preview.title") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            small
            dark
            icon
            color="primary background--text"
            @click="hideTrailerpreview"
            class="mx-0"
          >
            <v-icon small>$vuetify.icons.rms_close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <PreviewTrailer
            v-if="film.trailer"
            :url="film.trailer"
          ></PreviewTrailer>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PreviewTrailer from "@/components/screener/PreviewTrailer.vue";
import ZoomInfo from "@/components/screener/Zoom";
import FilmList from "./FilmList";
import { isSecondaryColorWhite } from "@/helpers";

export default {
  name: "Screener",
  props: {
    screener: {
      type: Object,
      default: null,
    },
    is_login_compo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PreviewTrailer,
    ZoomInfo,
    FilmList,
  },
  data() {
    return {
      showPreview: false,
      tab: "overview",
      film: null,
      videoOptions: {
        preload: "auto",
        controls: true,
        sources: [
          {
            type: "video/youtube",
            src: "https://www.youtube.com/watch?v=VakbpfZdjbE",
          },
        ],
      },
    };
  },
  computed:{
    isCreditOrTrailerAvailable(){
      return (this.screener &&
      this.screener.films.length == 1 &&
      (this.screener.films[0].director_name || this.screener.films[0].producer_name || this.screener.films[0].trailer));
    },
    ...mapState({
      currentCompany: (state) => state.company.company,
    }),
  },
  created(){
    this.loadQuillCss();
  },
  methods: {
    isSecondaryColorWhite: isSecondaryColorWhite,
    loadQuillCss(){
      let link = document.createElement("link");
      link.setAttribute("href", "https://cdn.quilljs.com/1.2.6/quill.snow.css");
      link.setAttribute("rel", "stylesheet");
      document.head.appendChild(link);
    },

    showTrailerpreview(event) {
      this.showPreview = true;
      this.film = event.film;
    },
    hideTrailerpreview() {
      this.showPreview = false;
      this.videoOptions.sources[0].src = null;
      this.videoOptions.sources[0].type = null;
      this.film = null;
    },
  },
};
</script>

<style>
.media_file_container {
  height: 100%;
  position: relative;
  width: 100%;
  background-color: #e2e2e2;
}
.text-align {
  text-align: justify;
}
.video-js {
  width: 100% !important;
  height: 40vmin;
}
.word-break {
  word-break: break-word;
}

.me-screener-desc img{
  max-width: 100%;
}
</style>
